import { isDefined } from '~/utils/guards/isDefined';
import { useToastCookie } from '~/utils/useToastCookie';

/**
 * Keep cart/compare toast modules out of the eager entry chunk via dynamic
 * import. Start after mount when a cart toast cookie is waiting; otherwise,
 * defer until Nuxt has completed its initial navigation and the browser is
 * idle. Both paths keep store setup from overlapping route middleware.
 *
 * Watchers use `{ immediate: true }` so actions that landed during the idle
 * window still toast once the modules attach.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const start = async () => {
    const [{ useCartToastNotifications }, { useCompareToastNotifications }] =
      await Promise.all([
        import('~/composables/useCartToastNotifications'),
        import('~/composables/useCompareToastNotifications')
      ]);
    useCartToastNotifications();
    useCompareToastNotifications();
  };

  const toastCookie = useToastCookie();
  if (isDefined(toastCookie.value) && toastCookie.value.context === 'cart') {
    nuxtApp.hook('app:mounted', () => {
      void start();
    });
    return;
  }

  onNuxtReady(() => {
    void start();
  });
});
